<template>
  <v-container fluid class="pa-5">
    <v-layout align-center justify-center my-2>
      <v-flex md8 class="headline">
        Campañas de call center
      </v-flex>
      <v-flex md4 class="d-flex align-center">
        <div class="px-3">
          <v-icon
            class="pa-2 cursor-pointer"
            :class="{
              rotated: refresh,
            }"
            small
            @click="refresh = !refresh">
            fa-refresh
          </v-icon>
        </div>
        <v-btn v-if="canCreateCallCenter" class="k-orange-linear white--text" block large @click="openModal()">
          Crear campaña de call center
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-3 mb-4>
      <v-flex md5 pr-3>
        <v-text-field
          v-model="callsListsSearch"
          label="Buscar..."
          color="black"
          solo>
        </v-text-field>
      </v-flex>
      <v-flex md3 pr-3>
        <v-select
          :multiple="true"
          v-model="filters.status"
          :overflow="true"
          :items="statuses"
          label="Estado"
          color="black"
          solo>
        </v-select>
      </v-flex>
      <v-flex md2 pr-3>
        <v-menu
          ref="startDatepickerRef"
          :close-on-content-click="false"
          v-model="startDatePicker"
          :nudge-right="40"
          :return-value.sync="filters.start_date"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px">
        <v-text-field
          slot="activator"
          :value="formatDate(filters.start_date, 'YYYY-MM-DD', 'DD/MM/YYYY')"
          prepend-icon="event"
          readonly
          solo/>
        <v-date-picker
          v-model="filters.start_date"
          @input="$refs.startDatepickerRef.save(filters.start_date)"
          color="k-orange-linear"/>
        </v-menu>
      </v-flex>
      <v-flex md2>
        <v-menu
          ref="endDatepickerRef"
          :close-on-content-click="false"
          v-model="endDatePicker"
          :nudge-right="40"
          :return-value.sync="filters.end_date"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px">
        <v-text-field
          slot="activator"
          :value="formatDate(filters.end_date, 'YYYY-MM-DD', 'DD/MM/YYYY')"
          prepend-icon="event"
          readonly
          solo/>
        <v-date-picker
          v-model="filters.end_date"
          @input="$refs.endDatepickerRef.save(filters.end_date)"
          color="k-orange-linear"/>
        </v-menu>
      </v-flex>
    </v-layout>
    <data-table
      ref="callsListsDialog"
      url="calls_lists"
      :search="callsListsSearch"
      :refresh="refresh"
      :filters="filters"
      @items-reload="callsLists = $event">
      <template slot="content" v-for="(item, i) in callsLists">
        <v-list-tile
          :key="`callList-${item.id}`"
          @click="startCallCenterNew(item)"
          avatar>
          <v-list-tile-avatar>
            <v-icon class="k-orange-linear-text" large>
              fas fa-file-alt
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>
                {{ item.name }}
              </strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ item.descrip }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <v-chip
            small
            flat
            class="bg-white">
            <v-icon class="pr-2 x-small-icon">fa fa-user</v-icon>
            {{ item.customers_total_qty }} / {{ item.customers_scheduled_qty }}
          </v-chip>
          <v-chip
            small
            flat
            class="bg-white">
            <v-icon class="pr-2 x-small-icon">fa fa-phone</v-icon>
            {{ item.total_calls || 0 }}
          </v-chip>
          <v-menu v-if="canEditCallCenter" offset-y @click.native.stop>
            <v-chip
              small
              slot="activator"
              :class="call_color(item.status)"
              class="white--text">
              <v-icon class="pr-2 x-small-icon" >{{call_icon(item.status)}}</v-icon>
              {{ call_name(item.status) }}
            </v-chip>
            <v-list v-if="canEditCallCenter">
              <v-list-tile v-for="(status, index) in statusExclude(item.status)" :key="index" @click="updateStatus(status.value, item)">
                <v-list-tile-title>{{status.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-chip v-else-if="canSeeCampaign"
            small
            :class="call_color(item.status)"
            class="white--text">
            <v-icon class="pr-2 x-small-icon" >{{call_icon(item.status)}}</v-icon>
            {{call_name(item.status)}}
          </v-chip>
          <v-btn v-if="canEditCallCenter" small icon @click.stop="openModal(item)">
            <v-icon small>fas fa-pencil-alt</v-icon>
          </v-btn>
        </v-list-tile>
        <v-divider
          v-if="i !== callsLists.length - 1"
          :key="`divider${i}`"/>
      </template>
    </data-table>
    <call-list
      :show="callListModal"
      :calls-lists-priority="callsListsPriority"
      :call-list="callList"
      @save="updateTable"
      @update="update"
      @close="closeModal">
    </call-list>
    <call-center-dialog
      :show="callCenterModal"
      :newInfra="registeringNewInfra"
      :call-list="callList"
      :disable-save-btn="disableSaveButton"
      @save="handleCall"
      @close="callCenterModal = false"/>
  </v-container>
</template>

<script>
import Vue from 'vue';
import store from '@/store/index';
import moment from 'moment';
import EventBus from '@/event-bus';
import filtersMixin from '@/mixins/workflowFilters';
import formatDateMixin from '@/mixins/formatDate';
import callListMixin from '@/mixins/callList';
import permissionsMixin from '@/mixins/permissions';
import DataTable from '@/components/global/DataTable2';
import CallList from '@/components/CallList/Modal/Index';
import CallCenterDialog from '@/components/CallList/Detail/ModalV2';

export default {
  beforeRouteEnter(to, from, next) {
    Promise.all([
      filtersMixin.methods.findFilters(),
      Vue.axios.get('check_release', { params: { name: 'call_list_queues' } }),
    ]).then((values) => {
      const active    = values[1].data.is_active;
      const retryConn = store.state.dialerV2.retryConnection;

      if (retryConn && active) {
        return next({ name: 'ConnectCampaign' });
      }
      next((vm) => {
        vm.redirectConnection = active;
      });
    }).catch(() => {});
  },
  components: {
    CallList,
    DataTable,
    CallCenterDialog,
  },
  mixins: [
    filtersMixin,
    formatDateMixin,
    callListMixin,
    permissionsMixin,
  ],
  data() {
    const now = moment();
    return {
      callCenterModal: false,
      callsLists: [],
      callsListsSearch: '',
      filters: {
        start_date: now.startOf('month').format('YYYY-MM-DD'),
        end_date: now.endOf('month').format('YYYY-MM-DD'),
        status: [1, 2, 3],
      },
      callListModal: false,
      endDatePicker: false,
      startDatePicker: false,
      callList: {},
      registeringNewInfra: false,
      loading: false,
      refresh: false,
      redirectConnection: false,
    };
  },
  computed: {
    callsListsPriority() {
      let calls = this.callsLists;
      calls = this.callsLists.filter(x => x.type_id != 3);
      return (calls.length || 0) + 1;
    },
    disableSaveButton() {
      return !this.callCenterModal || this.loading || this.callList.status !== 1;
    },
    canCreateCallCenter() {
      return this.checkPermissions([
        'create_call_center',
      ]);
    },
    canEditCallCenter() {
      return this.checkPermissions([
        'edit_call_center',
      ]);
    },
    canSeeCampaign() {
      return this.checkPermissions([
        'see_campaign_call_center',
      ]);
    },
  },
  methods: {
    openModal(item) {
      this.callList = {};
      this.callListModal = true;
      if (Object.keys(item || {}).length) {
        this.callList = item;
      }
    },
    update(data) {
      const call = this.callsLists.findIndex(x => x.id === data.id);
      this.$set(this.callsLists, call, {
        ...this.callsLists[call],
        ...data,
      });
    },
    closeModal() {
      this.callListModal = false;
      this.callList = {};
    },
    handleCall(data) {
      if (this.redirectConnection) {
        return this.$router.push('/calls_lists_v2');
      }

      if (this.registeringLiveKit) {
        return this.startLiveKit();
      }

      if (this.registeringNewInfra) {
        return this.startNewInfraCall();
      }

      return this.startCallCenter(data);
    },
    startCallCenter(data) {
      const body = {
        call_list_id: this.callList.id,
        call_type: data.call_type,
        zoom_url: data.zoom_url,
        conference_id: data.conference_id,
        access_code: data.access_code,
        receive_incoming_calls: data.receive_incoming_calls,
        max_commitment_days: this.callList.max_commitment_days,
        extension_number: data.extension_number,
        new_server: data.new_server,
      };
      if (data.call_type === 'zoom') {
        this.$store.dispatch('dialer/startCallCenterZoom', body);
      } else if (data.call_type === 'predictive') {
        this.$store.dispatch('dialer/startCallCenterPredictive', body);
      } else {
        this.$store.dispatch('dialer/startCallCenterSoftphone', body);
      }
    },
    async startCallCenterNew($event) {
      if (this.redirectConnection) {
        return this.$router.push('/call_center/connect');
      }

      this.registeringLiveKit   = false;
      this.registeringNewInfra  = false;

      // const [ result, err ] = await this.axios.get('check_release', {
      //   params: {
      //     name: 'livekit_server',
      //   },
      // })
      //   .then(({ data: { is_active: isActive } }) => ([ isActive, null ]))
      //   .catch(err => ([ null, err ]));
      const result = true;
      const err = null;

      if (err) {
        console.error(err);
        return EventBus.$emit('error', 'Ocurrio un error intente nuevamente');
      }

      // const [ result2, err2 ] = await this.axios.get('check_release', {
      //   params: {
      //     name: 'new_infra',
      //   },
      // })
      //   .then(({ data: { is_active: isActive } }) => ([ isActive, null ]))
      //   .catch(err => ([ null, err ]));
      const result2 = true;
      const err2 = null;

      if (err2) {
        console.error(err2);
        return EventBus.$emit('error', 'Ocurrio un error intente nuevamente');
      }

      this.callList         = $event;
      this.callCenterModal  = true;

      if (result) {
        this.registeringLiveKit   = true;
        this.registeringNewInfra  = true;
        return;
      }

      if (result2) {
        this.registeringNewInfra = true;
        return;
      }
    },
    startNewInfraCall() {
      return this.$store.dispatch('dialerV2/startCallCenter', {
        callListId: this.callList.id,
        maxCommitmentDays: this.callList.max_commitment_days,
      }).catch(() => {
        this.callCenterModal = false;
      });
    },
    startLiveKit() {
      return this.$store.dispatch('dialerV2/startLiveKit', {
        callListId: this.callList.id,
        maxCommitmentDays: this.callList.max_commitment_days,
      }).catch((err) => {
        EventBus.$emit('modal', err.message);
        this.callCenterModal = false;
      });
    },
    updateTable() {
      this.refresh = !this.refresh;
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
  border-radius: 50%;
  transform: rotate(0deg);
  transition: transform .25s linear;
}
.cursor-pointer.rotated {
  transform: rotate(360deg);
}
.cursor-pointer:hover {
  background-color: rgba(0,0,0,0.08);
}
</style>


// WEBPACK FOOTER //
// src/components/CallList/Index.vue